export const getUniqueArrayList = <T extends object>(array: T[], key: keyof T) => [...new Map(array.map((item: T) => [item[key], item])).values()]
